import styled, { keyframes } from "styled-components";

const ComparisonLoader = () => {
  return (
    <Wrapper>
      <div className="card-skeleton chart-skeleton">
        <div className="shimmer-line title" />
        <div className="shimmer-block chart-area" />
        <div className="shimmer-line legend" />
      </div>
      <div className="card-skeleton table-skeleton">
        <div className="shimmer-line title" />
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="shimmer-row">
            <div className="shimmer-line cell" />
            <div className="shimmer-line cell" />
            <div className="shimmer-line cell short" />
          </div>
        ))}
      </div>
    </Wrapper>
  );
};

export default ComparisonLoader;

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  .card-skeleton {
    background: ${({ theme }) => theme.widget.background};
    border-radius: 20px;
    padding: 25px;
    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.06));
  }

  .shimmer-line,
  .shimmer-block {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 800px 100%;
    animation: ${shimmer} 1.5s infinite linear;
    border-radius: 6px;
  }

  .shimmer-line.title {
    width: 200px;
    height: 20px;
    margin-bottom: 20px;
  }

  .shimmer-block.chart-area {
    width: 100%;
    height: 350px;
    margin-bottom: 12px;
  }

  .shimmer-line.legend {
    width: 300px;
    height: 14px;
    margin: 0 auto;
  }

  .shimmer-row {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;

    .cell {
      flex: 1;
      height: 16px;

      &.short {
        flex: 0.5;
      }
    }
  }
`;
